// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3gJc5","item":"PaymentsMobile_item__1IV2l","label":"PaymentsMobile_label__1gOEP","amount":"PaymentsMobile_amount__1LGvk"};